module.exports = __webpack_public_path__ + "img/木瓜3.ee75f61c.jpg";